// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Blog_container__PFID2 {
  width: 100%;
  padding: 5rem;
}

.Blog_title__YFDBv {
  width: 100%;
  background-color: var(--color-white);
  min-height: 20rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 3rem;
}

.Blog_nav__ELiUh {
  width: 100%;
  min-height: 12rem;
  display: grid;
  grid-template-columns: 1fr 38rem;
  padding: 0 5rem;
  gap: 5rem;
  align-items: center;
  background-color: var(--color-table-grey);
}
@media only screen and (max-width: 62.5em) {
  .Blog_nav__ELiUh {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 2rem;
    padding: 2rem 5rem;
  }
}
@media only screen and (max-width: 43.75em) {
  .Blog_nav__ELiUh {
    padding: 2rem;
  }
}
.Blog_nav__item__ovrPb {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
}
.Blog_nav__item__ovrPb > :not(:last-child) {
  margin-right: 1rem;
}
@media only screen and (max-width: 43.75em) {
  .Blog_nav__item__ovrPb {
    justify-content: flex-start;
  }
}
.Blog_nav__item__ovrPb nav {
  cursor: pointer;
  padding: 1rem;
  border-radius: 0.8rem;
}
.Blog_nav__item__ovrPb nav:hover {
  background-color: var(--color-table-grey-1);
}
.Blog_nav__item__selected__7B\\+YN {
  background-color: var(--color-table-grey-1);
  border-radius: 0.8rem;
  border: 1px solid var(--color-dark);
}

.Blog_blog__list__N7tn5 {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 2rem;
  row-gap: 7rem;
}
@media only screen and (max-width: 56.25em) {
  .Blog_blog__list__N7tn5 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Blog_blog__list__N7tn5 {
    grid-template-columns: 1fr;
  }
}
.Blog_blog__list__single__in\\+e7 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.Blog_blog__list__single__img__WgNlq {
  width: 100%;
  height: 25rem;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.Blog_blog__list__single__img__WgNlq:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}
.Blog_blog__list__single__img__container__QAKCn {
  width: 100%;
  overflow: hidden;
  transition: transform 0.3s ease;
  border-radius: 2rem;
}
.Blog_blog__list__single__flex__hDPU6 {
  display: flex;
}
.Blog_blog__list__single__flex__hDPU6 > :not(:last-child) {
  margin-right: 1rem;
}
.Blog_blog__list__single__flex__hDPU6 {
  align-items: center;
}
.Blog_blog__list__single__tags__MmKaZ {
  display: flex;
}
.Blog_blog__list__single__tags__MmKaZ > :not(:last-child) {
  margin-right: 1rem;
}
.Blog_blog__list__single__tags__MmKaZ {
  background-color: var(--color-primary-3);
  font-size: var(--default-font-small);
  font-weight: 700;
  padding: 0.8rem;
  border-radius: 0.8rem;
}
.Blog_blog__list__single__read__VW1mB {
  display: flex;
  align-items: center;
  color: var(--color-primary);
  cursor: pointer;
}
.Blog_blog__list__single__read__VW1mB:hover {
  color: var(--color-primary-4);
}
.Blog_blog__list__single__read__VW1mB > :not(:last-child) {
  margin-right: 1rem;
}
.Blog_blog__list__single__read__VW1mB > :last-child {
  font-size: 2.4rem;
}

.Blog_single__KQAG- {
  padding: 3rem 10rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media only screen and (max-width: 37.5em) {
  .Blog_single__KQAG- {
    padding: 3rem;
  }
}
.Blog_single__author__iBblt {
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;
}
.Blog_single__img__1wxG5 {
  width: 100rem;
  height: 40rem;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.3s ease;
  margin-bottom: 6rem;
  border-radius: 1rem;
}
.Blog_single__img__1wxG5:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}
@media only screen and (max-width: 37.5em) {
  .Blog_single__img__1wxG5 {
    width: 100%;
    height: 24rem;
  }
}
.Blog_single__content__spLNT {
  display: grid;
  grid-template-columns: 50rem 1fr;
  gap: 3rem;
}
@media only screen and (max-width: 68.75em) {
  .Blog_single__content__spLNT {
    display: flex;
    flex-direction: column-reverse;
  }
}
.Blog_single__content__1__70wD5 {
  padding: 3rem;
  background-color: var(--color-primary-4);
  height: fit-content;
  border-radius: 1rem;
}
.Blog_single__content__2__2MRf2 {
  width: 80rem;
}
@media only screen and (max-width: 50em) {
  .Blog_single__content__2__2MRf2 {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Blog/Blog.module.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,aAAA;AADJ;;AAIA;EACI,WAAA;EACA,oCAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,gCAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,yCAAA;AADJ;AAGI;EAVJ;IAWQ,0BAAA;IACA,qBAAA;IACA,SAAA;IACA,kBAAA;EAAN;AACF;AAEI;EAjBJ;IAkBQ,aAAA;EACN;AACF;AAGI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AADR;AAGQ;EACI,kBAAA;AADZ;AAIQ;EAVJ;IAWQ,2BAAA;EADV;AACF;AAGQ;EACI,eAAA;EACA,aAAA;EACA,qBAAA;AADZ;AAGY;EACI,2CAAA;AADhB;AAMQ;EACI,2CAAA;EACA,qBAAA;EACA,mCAAA;AAJZ;;AAUI;EACI,WAAA;EACA,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,aAAA;AAPR;AASQ;EAPJ;IAQQ,qCAAA;EANV;AACF;AAQQ;EAXJ;IAYQ,0BAAA;EALV;AACF;AAOQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AALZ;AAOY;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,+BAAA;AALhB;AAOgB;EACI,qBAAA;EACA,+BAAA;AALpB;AAQgB;EACI,WAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;AANpB;AAWY;EACI,aAAA;AAThB;AAWgB;EACI,kBAAA;AATpB;AAKY;EAOI,mBAAA;AAThB;AAYY;EACI,aAAA;AAVhB;AAYgB;EACI,kBAAA;AAVpB;AAMY;EAOI,wCAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAVhB;AAaY;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AAXhB;AAagB;EACI,6BAAA;AAXpB;AAcgB;EACI,kBAAA;AAZpB;AAegB;EACI,iBAAA;AAbpB;;AAsBA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAnBJ;AAqBI;EANJ;IAOQ,aAAA;EAlBN;AACF;AAqBI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAnBR;AAsBI;EACI,aAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,+BAAA;EACA,mBAAA;EACA,mBAAA;AApBR;AAsBQ;EACI,qBAAA;EACA,+BAAA;AApBZ;AAuBQ;EAdJ;IAeQ,WAAA;IACA,aAAA;EApBV;AACF;AAuBI;EACI,aAAA;EACA,gCAAA;EACA,SAAA;AArBR;AAuBQ;EALJ;IAMQ,aAAA;IACA,8BAAA;EApBV;AACF;AAsBQ;EACI,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;AApBZ;AAuBQ;EACI,YAAA;AArBZ;AAuBY;EAHJ;IAIQ,WAAA;EApBd;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n    width: 100%;\n    padding: 5rem;\n}\n\n.title {\n    width: 100%;\n    background-color: var(--color-white);\n    min-height: 20rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 4rem 3rem;\n}\n\n.nav {\n    width: 100%;\n    min-height: 12rem;\n    display: grid;\n    grid-template-columns: 1fr 38rem;\n    padding: 0 5rem;\n    gap: 5rem;\n    align-items: center;\n    background-color: var(--color-table-grey);\n\n    @media only screen and (max-width: $bp-1000) {\n        grid-template-columns: 1fr;\n        justify-items: center;\n        gap: 2rem;\n        padding: 2rem 5rem;\n    }\n\n    @media only screen and (max-width: $bp-700) {\n        padding: 2rem;\n    }\n\n\n\n    &__item {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        flex-wrap: wrap;\n\n        &>:not(:last-child) {\n            margin-right: 1rem;\n        }\n\n        @media only screen and (max-width: $bp-700) {\n            justify-content: flex-start;\n        }\n\n        nav {\n            cursor: pointer;\n            padding: 1rem;\n            border-radius: 0.8rem;\n\n            &:hover {\n                background-color: var(--color-table-grey-1);\n            }\n        }\n\n\n        &__selected {\n            background-color: var(--color-table-grey-1);\n            border-radius: 0.8rem;\n            border: 1px solid var(--color-dark);\n        }\n    }\n}\n\n.blog {\n    &__list {\n        width: 100%;\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        column-gap: 2rem;\n        row-gap: 7rem;\n\n        @media only screen and (max-width: $bp-900) {\n            grid-template-columns: repeat(2, 1fr);\n        }\n\n        @media only screen and (max-width: $bp-600) {\n            grid-template-columns: 1fr;\n        }\n\n        &__single {\n            display: flex;\n            flex-direction: column;\n            gap: 1rem;\n\n            &__img {\n                width: 100%;\n                height: 25rem;\n                object-fit: cover;\n                cursor: pointer;\n                transition: transform 0.3s ease;\n\n                &:hover {\n                    transform: scale(1.1);\n                    transition: transform 0.3s ease;\n                }\n\n                &__container {\n                    width: 100%;\n                    overflow: hidden;\n                    transition: transform 0.3s ease;\n                    border-radius: 2rem;\n                }\n\n            }\n\n            &__flex {\n                display: flex;\n\n                &> :not(:last-child) {\n                    margin-right: 1rem;\n                }\n\n                align-items: center;\n            }\n\n            &__tags {\n                display: flex;\n\n                &> :not(:last-child) {\n                    margin-right: 1rem;\n                }\n\n                background-color: var(--color-primary-3);\n                font-size: var(--default-font-small);\n                font-weight: 700;\n                padding: 0.8rem;\n                border-radius: 0.8rem;\n            }\n\n            &__read {\n                display: flex;\n                align-items: center;\n                color: var(--color-primary);\n                cursor: pointer;\n\n                &:hover {\n                    color: var(--color-primary-4);\n                }\n\n                &> :not(:last-child) {\n                    margin-right: 1rem;\n                }\n\n                &>:last-child {\n                    font-size: 2.4rem;\n                }\n            }\n\n\n        }\n    }\n}\n\n.single {\n    padding: 3rem 10rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    @media only screen and (max-width: $bp-600) {\n        padding: 3rem;\n    }\n\n\n    &__author {\n        display: flex;\n        gap: 2rem;\n        align-items: center;\n        flex-wrap: wrap;\n    }\n\n    &__img {\n        width: 100rem;\n        height: 40rem;\n        object-fit: cover;\n        cursor: pointer;\n        transition: transform 0.3s ease;\n        margin-bottom: 6rem;\n        border-radius: 1rem;\n\n        &:hover {\n            transform: scale(1.1);\n            transition: transform 0.3s ease;\n        }\n\n        @media only screen and (max-width: $bp-600) {\n            width: 100%;\n            height: 24rem;\n        }\n    }\n\n    &__content {\n        display: grid;\n        grid-template-columns: 50rem 1fr;\n        gap: 3rem;\n\n        @media only screen and (max-width: $bp-1100) {\n            display: flex;\n            flex-direction: column-reverse;\n        }\n\n        &__1 {\n            padding: 3rem;\n            background-color: var(--color-primary-4);\n            height: fit-content;\n            border-radius: 1rem;\n        }\n\n        &__2 {\n            width: 80rem;\n\n            @media only screen and (max-width: $bp-800) {\n                width: 100%;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Blog_container__PFID2`,
	"title": `Blog_title__YFDBv`,
	"nav": `Blog_nav__ELiUh`,
	"nav__item": `Blog_nav__item__ovrPb`,
	"nav__item__selected": `Blog_nav__item__selected__7B+YN`,
	"blog__list": `Blog_blog__list__N7tn5`,
	"blog__list__single": `Blog_blog__list__single__in+e7`,
	"blog__list__single__img": `Blog_blog__list__single__img__WgNlq`,
	"blog__list__single__img__container": `Blog_blog__list__single__img__container__QAKCn`,
	"blog__list__single__flex": `Blog_blog__list__single__flex__hDPU6`,
	"blog__list__single__tags": `Blog_blog__list__single__tags__MmKaZ`,
	"blog__list__single__read": `Blog_blog__list__single__read__VW1mB`,
	"single": `Blog_single__KQAG-`,
	"single__author": `Blog_single__author__iBblt`,
	"single__img": `Blog_single__img__1wxG5`,
	"single__content": `Blog_single__content__spLNT`,
	"single__content__1": `Blog_single__content__1__70wD5`,
	"single__content__2": `Blog_single__content__2__2MRf2`
};
export default ___CSS_LOADER_EXPORT___;
